module.exports = __webpack_public_path__ + "img/Reacondicionarte_banner_superior.0e6dac30.jpg";